import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  services: [{}],
  service: {},
  newService: {},
  updatedService: {},
  deletedService: {},
  error: null,
};

const companyServiceSlice = createSlice({
  name: 'companyService',
  initialState,
  reducers: {
    setReducerError: (state, action) => {
      state.error = action.payload;
    },
    setServices: (state, action) => {
      state.services = action.payload;
      state.error = null;
    },
    setService: (state, action) => {
      state.service = action.payload;
      state.error = null;
    },
    setNewService: (state, action) => {
      state.newService = action.payload;
      state.error = null;
    },
    setUpdatedService: (state, action) => {
      state.updatedService = action.payload;
      state.error = null;
    },
    setDeletedService: (state, action) => {
      state.deletedService = action.payload;
      state.error = null;
    },
    setResetCompanyService: () => {
      return initialState;
    },
  },
});

export const {
  setReducerError,
  setServices,
  setService,
  setNewService,
  setUpdatedService,
  setDeletedService,
  setResetCompanyService,
} = companyServiceSlice.actions;

export default companyServiceSlice.reducer;
